var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_876_6945",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "#D9D9D9",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_876_6945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.70096 10.9939L8.40626 10.2634L10.6464 12.5036L11.5 13.3571V12.15V4.5H12.5V12.15V13.3571L13.3536 12.5036L15.5937 10.2634L16.299 10.9939L12 15.2929L7.70096 10.9939ZM18.5 18V15.5H19.5V18C19.5 18.4163 19.3576 18.7603 19.0589 19.0589C18.7603 19.3576 18.4163 19.5 18 19.5H6C5.58366 19.5 5.2397 19.3576 4.94105 19.0589C4.64241 18.7603 4.5 18.4163 4.5 18V15.5H5.5V18V18.5H6H18H18.5V18Z",
    fill: "#1C1B1F",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.fba400f02795ac37d2c3bc3c4afc8e12.svg";
export { ForwardRef as ReactComponent };